import { useEffect, useState, type ReactNode } from 'react';

/**
 * Минимальный роутер на History API. Полноценная библиотека здесь не окупается:
 * маршрутов пять, вложенности нет, а каждая внешняя зависимость на фронте
 * ученика — это лишние килобайты на мобильном интернете.
 */
export function usePath(): string {
  const [path, setPath] = useState(location.pathname);
  useEffect(() => {
    const onChange = () => setPath(location.pathname);
    window.addEventListener('popstate', onChange);
    window.addEventListener('navigate', onChange as EventListener);
    return () => {
      window.removeEventListener('popstate', onChange);
      window.removeEventListener('navigate', onChange as EventListener);
    };
  }, []);
  return path;
}

export function navigate(to: string): void {
  if (location.pathname === to) return;
  history.pushState({}, '', to);
  window.dispatchEvent(new Event('navigate'));
}

export function Link({ to, children, className }: { to: string; children: ReactNode; className?: string }) {
  const path = usePath();
  return (
    <a
      href={to}
      className={className}
      aria-current={path === to ? 'page' : undefined}
      onClick={(e) => {
        // Ctrl/Cmd-клик и средняя кнопка должны открывать вкладку как обычно.
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        e.preventDefault();
        navigate(to);
      }}
    >
      {children}
    </a>
  );
}
